import tw, { styled } from 'twin.macro';

const StyledLink = styled.a`
  ${tw`text-nIndigo-600 underline hover:no-underline`};
`;

export default StyledLink;
